// Generated from libphonenumber regions; sorted by country name.
export const COUNTRIES = [
  ["AF", "Afghanistan", "+93"],
  ["AX", "Åland Islands", "+358"],
  ["AL", "Albania", "+355"],
  ["DZ", "Algeria", "+213"],
  ["AS", "American Samoa", "+1"],
  ["AD", "Andorra", "+376"],
  ["AO", "Angola", "+244"],
  ["AI", "Anguilla", "+1"],
  ["AG", "Antigua and Barbuda", "+1"],
  ["AR", "Argentina", "+54"],
  ["AM", "Armenia", "+374"],
  ["AW", "Aruba", "+297"],
  ["AU", "Australia", "+61"],
  ["AT", "Austria", "+43"],
  ["AZ", "Azerbaijan", "+994"],
  ["BS", "Bahamas", "+1"],
  ["BH", "Bahrain", "+973"],
  ["BD", "Bangladesh", "+880"],
  ["BB", "Barbados", "+1"],
  ["BY", "Belarus", "+375"],
  ["BE", "Belgium", "+32"],
  ["BZ", "Belize", "+501"],
  ["BJ", "Benin", "+229"],
  ["BM", "Bermuda", "+1"],
  ["BT", "Bhutan", "+975"],
  ["BO", "Bolivia", "+591"],
  ["BQ", "Bonaire, Sint Eustatius and Saba", "+599"],
  ["BA", "Bosnia and Herzegovina", "+387"],
  ["BW", "Botswana", "+267"],
  ["BR", "Brazil", "+55"],
  ["IO", "British Indian Ocean Territory", "+246"],
  ["BN", "Brunei Darussalam", "+673"],
  ["BG", "Bulgaria", "+359"],
  ["BF", "Burkina Faso", "+226"],
  ["BI", "Burundi", "+257"],
  ["CV", "Cabo Verde", "+238"],
  ["KH", "Cambodia", "+855"],
  ["CM", "Cameroon", "+237"],
  ["CA", "Canada", "+1"],
  ["KY", "Cayman Islands", "+1"],
  ["CF", "Central African Republic", "+236"],
  ["TD", "Chad", "+235"],
  ["CL", "Chile", "+56"],
  ["CN", "China", "+86"],
  ["CX", "Christmas Island", "+61"],
  ["CC", "Cocos (Keeling) Islands", "+61"],
  ["CO", "Colombia", "+57"],
  ["KM", "Comoros", "+269"],
  ["CG", "Congo", "+242"],
  ["CD", "Congo, The Democratic Republic of the", "+243"],
  ["CK", "Cook Islands", "+682"],
  ["CR", "Costa Rica", "+506"],
  ["CI", "Côte d'Ivoire", "+225"],
  ["HR", "Croatia", "+385"],
  ["CU", "Cuba", "+53"],
  ["CW", "Curaçao", "+599"],
  ["CY", "Cyprus", "+357"],
  ["CZ", "Czechia", "+420"],
  ["DK", "Denmark", "+45"],
  ["DJ", "Djibouti", "+253"],
  ["DM", "Dominica", "+1"],
  ["DO", "Dominican Republic", "+1"],
  ["EC", "Ecuador", "+593"],
  ["EG", "Egypt", "+20"],
  ["SV", "El Salvador", "+503"],
  ["GQ", "Equatorial Guinea", "+240"],
  ["ER", "Eritrea", "+291"],
  ["EE", "Estonia", "+372"],
  ["SZ", "Eswatini", "+268"],
  ["ET", "Ethiopia", "+251"],
  ["FK", "Falkland Islands (Malvinas)", "+500"],
  ["FO", "Faroe Islands", "+298"],
  ["FJ", "Fiji", "+679"],
  ["FI", "Finland", "+358"],
  ["FR", "France", "+33"],
  ["GF", "French Guiana", "+594"],
  ["PF", "French Polynesia", "+689"],
  ["GA", "Gabon", "+241"],
  ["GM", "Gambia", "+220"],
  ["GE", "Georgia", "+995"],
  ["DE", "Germany", "+49"],
  ["GH", "Ghana", "+233"],
  ["GI", "Gibraltar", "+350"],
  ["GR", "Greece", "+30"],
  ["GL", "Greenland", "+299"],
  ["GD", "Grenada", "+1"],
  ["GP", "Guadeloupe", "+590"],
  ["GU", "Guam", "+1"],
  ["GT", "Guatemala", "+502"],
  ["GG", "Guernsey", "+44"],
  ["GN", "Guinea", "+224"],
  ["GW", "Guinea-Bissau", "+245"],
  ["GY", "Guyana", "+592"],
  ["HT", "Haiti", "+509"],
  ["VA", "Holy See (Vatican City State)", "+39"],
  ["HN", "Honduras", "+504"],
  ["HK", "Hong Kong", "+852"],
  ["HU", "Hungary", "+36"],
  ["IS", "Iceland", "+354"],
  ["IN", "India", "+91"],
  ["ID", "Indonesia", "+62"],
  ["IR", "Iran", "+98"],
  ["IQ", "Iraq", "+964"],
  ["IE", "Ireland", "+353"],
  ["IM", "Isle of Man", "+44"],
  ["IL", "Israel", "+972"],
  ["IT", "Italy", "+39"],
  ["JM", "Jamaica", "+1"],
  ["JP", "Japan", "+81"],
  ["JE", "Jersey", "+44"],
  ["JO", "Jordan", "+962"],
  ["KZ", "Kazakhstan", "+7"],
  ["KE", "Kenya", "+254"],
  ["KI", "Kiribati", "+686"],
  ["KW", "Kuwait", "+965"],
  ["KG", "Kyrgyzstan", "+996"],
  ["LA", "Laos", "+856"],
  ["LV", "Latvia", "+371"],
  ["LB", "Lebanon", "+961"],
  ["LS", "Lesotho", "+266"],
  ["LR", "Liberia", "+231"],
  ["LY", "Libya", "+218"],
  ["LI", "Liechtenstein", "+423"],
  ["LT", "Lithuania", "+370"],
  ["LU", "Luxembourg", "+352"],
  ["MO", "Macao", "+853"],
  ["MG", "Madagascar", "+261"],
  ["MW", "Malawi", "+265"],
  ["MY", "Malaysia", "+60"],
  ["MV", "Maldives", "+960"],
  ["ML", "Mali", "+223"],
  ["MT", "Malta", "+356"],
  ["MH", "Marshall Islands", "+692"],
  ["MQ", "Martinique", "+596"],
  ["MR", "Mauritania", "+222"],
  ["MU", "Mauritius", "+230"],
  ["YT", "Mayotte", "+262"],
  ["MX", "Mexico", "+52"],
  ["FM", "Micronesia, Federated States of", "+691"],
  ["MD", "Moldova", "+373"],
  ["MC", "Monaco", "+377"],
  ["MN", "Mongolia", "+976"],
  ["ME", "Montenegro", "+382"],
  ["MS", "Montserrat", "+1"],
  ["MA", "Morocco", "+212"],
  ["MZ", "Mozambique", "+258"],
  ["MM", "Myanmar", "+95"],
  ["NA", "Namibia", "+264"],
  ["NR", "Nauru", "+674"],
  ["NP", "Nepal", "+977"],
  ["NL", "Netherlands", "+31"],
  ["NC", "New Caledonia", "+687"],
  ["NZ", "New Zealand", "+64"],
  ["NI", "Nicaragua", "+505"],
  ["NE", "Niger", "+227"],
  ["NG", "Nigeria", "+234"],
  ["NU", "Niue", "+683"],
  ["NF", "Norfolk Island", "+672"],
  ["KP", "North Korea", "+850"],
  ["MK", "North Macedonia", "+389"],
  ["MP", "Northern Mariana Islands", "+1"],
  ["NO", "Norway", "+47"],
  ["OM", "Oman", "+968"],
  ["PK", "Pakistan", "+92"],
  ["PW", "Palau", "+680"],
  ["PS", "Palestine, State of", "+970"],
  ["PA", "Panama", "+507"],
  ["PG", "Papua New Guinea", "+675"],
  ["PY", "Paraguay", "+595"],
  ["PE", "Peru", "+51"],
  ["PH", "Philippines", "+63"],
  ["PL", "Poland", "+48"],
  ["PT", "Portugal", "+351"],
  ["PR", "Puerto Rico", "+1"],
  ["QA", "Qatar", "+974"],
  ["RE", "Réunion", "+262"],
  ["RO", "Romania", "+40"],
  ["RU", "Russian Federation", "+7"],
  ["RW", "Rwanda", "+250"],
  ["BL", "Saint Barthélemy", "+590"],
  ["SH", "Saint Helena, Ascension and Tristan da Cunha", "+290"],
  ["KN", "Saint Kitts and Nevis", "+1"],
  ["LC", "Saint Lucia", "+1"],
  ["MF", "Saint Martin (French part)", "+590"],
  ["PM", "Saint Pierre and Miquelon", "+508"],
  ["VC", "Saint Vincent and the Grenadines", "+1"],
  ["WS", "Samoa", "+685"],
  ["SM", "San Marino", "+378"],
  ["ST", "Sao Tome and Principe", "+239"],
  ["SA", "Saudi Arabia", "+966"],
  ["SN", "Senegal", "+221"],
  ["RS", "Serbia", "+381"],
  ["SC", "Seychelles", "+248"],
  ["SL", "Sierra Leone", "+232"],
  ["SG", "Singapore", "+65"],
  ["SX", "Sint Maarten (Dutch part)", "+1"],
  ["SK", "Slovakia", "+421"],
  ["SI", "Slovenia", "+386"],
  ["SB", "Solomon Islands", "+677"],
  ["SO", "Somalia", "+252"],
  ["ZA", "South Africa", "+27"],
  ["KR", "South Korea", "+82"],
  ["SS", "South Sudan", "+211"],
  ["ES", "Spain", "+34"],
  ["LK", "Sri Lanka", "+94"],
  ["SD", "Sudan", "+249"],
  ["SR", "Suriname", "+597"],
  ["SJ", "Svalbard and Jan Mayen", "+47"],
  ["SE", "Sweden", "+46"],
  ["CH", "Switzerland", "+41"],
  ["SY", "Syria", "+963"],
  ["TW", "Taiwan", "+886"],
  ["TJ", "Tajikistan", "+992"],
  ["TZ", "Tanzania", "+255"],
  ["TH", "Thailand", "+66"],
  ["TL", "Timor-Leste", "+670"],
  ["TG", "Togo", "+228"],
  ["TK", "Tokelau", "+690"],
  ["TO", "Tonga", "+676"],
  ["TT", "Trinidad and Tobago", "+1"],
  ["TN", "Tunisia", "+216"],
  ["TR", "Türkiye", "+90"],
  ["TM", "Turkmenistan", "+993"],
  ["TC", "Turks and Caicos Islands", "+1"],
  ["TV", "Tuvalu", "+688"],
  ["UG", "Uganda", "+256"],
  ["UA", "Ukraine", "+380"],
  ["AE", "United Arab Emirates", "+971"],
  ["GB", "United Kingdom", "+44"],
  ["US", "United States", "+1"],
  ["UY", "Uruguay", "+598"],
  ["UZ", "Uzbekistan", "+998"],
  ["VU", "Vanuatu", "+678"],
  ["VE", "Venezuela", "+58"],
  ["VN", "Vietnam", "+84"],
  ["VG", "Virgin Islands, British", "+1"],
  ["VI", "Virgin Islands, U.S.", "+1"],
  ["WF", "Wallis and Futuna", "+681"],
  ["EH", "Western Sahara", "+212"],
  ["YE", "Yemen", "+967"],
  ["ZM", "Zambia", "+260"],
  ["ZW", "Zimbabwe", "+263"],
];

export const MAIN_REGION = {"+93": "AF", "+355": "AL", "+213": "DZ", "+1": "US", "+376": "AD", "+244": "AO", "+54": "AR", "+374": "AM", "+297": "AW", "+61": "AU", "+43": "AT", "+994": "AZ", "+973": "BH", "+880": "BD", "+375": "BY", "+32": "BE", "+501": "BZ", "+229": "BJ", "+975": "BT", "+591": "BO", "+599": "CW", "+387": "BA", "+267": "BW", "+55": "BR", "+246": "IO", "+673": "BN", "+359": "BG", "+226": "BF", "+257": "BI", "+238": "CV", "+855": "KH", "+237": "CM", "+236": "CF", "+235": "TD", "+56": "CL", "+86": "CN", "+57": "CO", "+269": "KM", "+242": "CG", "+243": "CD", "+682": "CK", "+506": "CR", "+385": "HR", "+53": "CU", "+357": "CY", "+420": "CZ", "+225": "CI", "+45": "DK", "+253": "DJ", "+593": "EC", "+20": "EG", "+503": "SV", "+240": "GQ", "+291": "ER", "+372": "EE", "+268": "SZ", "+251": "ET", "+500": "FK", "+298": "FO", "+679": "FJ", "+358": "FI", "+33": "FR", "+594": "GF", "+689": "PF", "+241": "GA", "+220": "GM", "+995": "GE", "+49": "DE", "+233": "GH", "+350": "GI", "+30": "GR", "+299": "GL", "+590": "GP", "+502": "GT", "+44": "GB", "+224": "GN", "+245": "GW", "+592": "GY", "+509": "HT", "+39": "IT", "+504": "HN", "+852": "HK", "+36": "HU", "+354": "IS", "+91": "IN", "+62": "ID", "+98": "IR", "+964": "IQ", "+353": "IE", "+972": "IL", "+81": "JP", "+962": "JO", "+7": "RU", "+254": "KE", "+686": "KI", "+965": "KW", "+996": "KG", "+856": "LA", "+371": "LV", "+961": "LB", "+266": "LS", "+231": "LR", "+218": "LY", "+423": "LI", "+370": "LT", "+352": "LU", "+853": "MO", "+261": "MG", "+265": "MW", "+60": "MY", "+960": "MV", "+223": "ML", "+356": "MT", "+692": "MH", "+596": "MQ", "+222": "MR", "+230": "MU", "+262": "RE", "+52": "MX", "+691": "FM", "+373": "MD", "+377": "MC", "+976": "MN", "+382": "ME", "+212": "MA", "+258": "MZ", "+95": "MM", "+264": "NA", "+674": "NR", "+977": "NP", "+31": "NL", "+687": "NC", "+64": "NZ", "+505": "NI", "+227": "NE", "+234": "NG", "+683": "NU", "+672": "NF", "+850": "KP", "+389": "MK", "+47": "NO", "+968": "OM", "+92": "PK", "+680": "PW", "+970": "PS", "+507": "PA", "+675": "PG", "+595": "PY", "+51": "PE", "+63": "PH", "+48": "PL", "+351": "PT", "+974": "QA", "+40": "RO", "+250": "RW", "+290": "SH", "+508": "PM", "+685": "WS", "+378": "SM", "+239": "ST", "+966": "SA", "+221": "SN", "+381": "RS", "+248": "SC", "+232": "SL", "+65": "SG", "+421": "SK", "+386": "SI", "+677": "SB", "+252": "SO", "+27": "ZA", "+82": "KR", "+211": "SS", "+34": "ES", "+94": "LK", "+249": "SD", "+597": "SR", "+46": "SE", "+41": "CH", "+963": "SY", "+886": "TW", "+992": "TJ", "+255": "TZ", "+66": "TH", "+670": "TL", "+228": "TG", "+690": "TK", "+676": "TO", "+216": "TN", "+993": "TM", "+688": "TV", "+90": "TR", "+256": "UG", "+380": "UA", "+971": "AE", "+598": "UY", "+998": "UZ", "+678": "VU", "+58": "VE", "+84": "VN", "+681": "WF", "+967": "YE", "+260": "ZM", "+263": "ZW"};
